import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const InvoiceTable = ({ data }) => (
  <TableContainer component={Paper}>
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <StyledTableCell align='center'>Date</StyledTableCell>
          <StyledTableCell align='center'>Order Number</StyledTableCell>
          <StyledTableCell align='center'>Source</StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row) => (
          <StyledTableRow key={row.orderNumber}>
            <StyledTableCell align='center'>{row.date}</StyledTableCell>
            <StyledTableCell align='center'>{row.orderNumber}</StyledTableCell>
            <StyledTableCell align='center'>{row.source}</StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default InvoiceTable;
